var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1973352730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2288"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "rotate(180 7 7)",
    fill: "#60B0F9",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.67656,
    transform: "rotate(180 7 7)",
    stroke: "url(#paint0_linear_17475_24128)",
    strokeOpacity: 0.3,
    strokeWidth: 0.646875
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.15365 8.65365C5.26433 8.76433 5.41436 8.82658 5.57107 8.82682C5.72778 8.82706 5.87757 8.76456 5.98849 8.65365L7.90433 6.73781L7.90433 7.81452C7.89168 7.97838 7.94822 8.14034 8.05961 8.26128C8.17124 8.38197 8.32843 8.45043 8.49277 8.45067C8.65735 8.45066 8.8143 8.38197 8.92593 8.26128C9.03756 8.14058 9.09409 7.97862 9.08121 7.81452L9.08121 5.31C9.08169 5.15257 9.01967 5.00135 8.90828 4.88996C8.79689 4.77856 8.6459 4.71631 8.48824 4.71702L5.98372 4.71703C5.78407 4.73253 5.60613 4.84798 5.51048 5.02377C5.41484 5.19956 5.41484 5.41185 5.51048 5.58764C5.60613 5.76344 5.78407 5.87888 5.98348 5.89415L7.06877 5.90274L5.15317 7.81833C5.0425 7.92901 4.98024 8.07904 4.98 8.23575C4.97977 8.39246 5.04297 8.54297 5.15365 8.65365Z",
    fill: "#8DC8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17475_24128",
    x1: -3.675,
    y1: -20.65,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/Checkout.71e93044bd0f4d7dd85b1d46be5e96da.svg";
export { ForwardRef as ReactComponent };